import type { RecipeVariants } from "@vanilla-extract/recipes";
import type { ReactNode } from "react";
import { table } from "./style.css.ts";

function TableContainer(props: { children: ReactNode }) {
  return <table className={table.container}>{props.children}</table>;
}

type TableData = Record<string, ReactNode>;

type ColumnDefinition<T extends TableData> = {
  key: keyof T & string;
  label: string;
  inlineSize?: string;
} & RecipeVariants<typeof table.cell>;

export function Table<T extends TableData>(props: {
  columns: ColumnDefinition<T>[];
  data: T[];
}) {
  const { columns, data } = props;

  return (
    <TableContainer>
      <thead>
        <tr className={table.row()}>
          {columns.map((col) => {
            const { key, label, inlineSize, ...variants } = col;

            return (
              <th
                key={key}
                className={table.cell(variants)}
                style={{ inlineSize, fontSize: "0.9em" }}
              >
                {label}
              </th>
            );
          })}
        </tr>
      </thead>

      <tbody>
        {data.map((row, index) => {
          return (
            <tr key={index} className={table.row({ withBorder: true })}>
              {columns.map(({ key, padding, align }) => {
                return (
                  <td key={key} className={table.cell({ align, padding })}>
                    {row[key]}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </TableContainer>
  );
}
